var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeEditor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.72925L9.75 11.2292L7.25 13.7292",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 11.7292H17.25",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 2.97925C14.7994 2.97925 14.8478 2.99391 14.8889 3.02138C14.93 3.04885 14.962 3.0879 14.981 3.13358C14.9999 3.17926 15.0048 3.22953 14.9952 3.27802C14.9856 3.32652 14.9617 3.37106 14.9268 3.40602C14.8918 3.44099 14.8473 3.4648 14.7988 3.47444C14.7503 3.48409 14.7 3.47914 14.6543 3.46022C14.6086 3.4413 14.5696 3.40925 14.5421 3.36814C14.5147 3.32703 14.5 3.27869 14.5 3.22925C14.5 3.16294 14.5263 3.09936 14.5732 3.05247C14.6201 3.00559 14.6837 2.97925 14.75 2.97925Z",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 2.97925C17.7994 2.97925 17.8478 2.99391 17.8889 3.02138C17.93 3.04885 17.962 3.0879 17.981 3.13358C17.9999 3.17926 18.0048 3.22953 17.9952 3.27802C17.9855 3.32652 17.9617 3.37106 17.9268 3.40602C17.8918 3.44099 17.8473 3.4648 17.7988 3.47444C17.7503 3.48409 17.7 3.47914 17.6543 3.46022C17.6086 3.4413 17.5696 3.40925 17.5421 3.36814C17.5147 3.32703 17.5 3.27869 17.5 3.22925C17.5 3.16294 17.5263 3.09936 17.5732 3.05247C17.6201 3.00559 17.6837 2.97925 17.75 2.97925Z",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 2.97925C20.7994 2.97925 20.8478 2.99391 20.8889 3.02138C20.93 3.04885 20.962 3.0879 20.981 3.13358C20.9999 3.17926 21.0048 3.22953 20.9952 3.27802C20.9855 3.32652 20.9617 3.37106 20.9268 3.40602C20.8918 3.44099 20.8473 3.4648 20.7988 3.47444C20.7503 3.48409 20.7 3.47914 20.6543 3.46022C20.6086 3.4413 20.5696 3.40925 20.5421 3.36814C20.5147 3.32703 20.5 3.27869 20.5 3.22925C20.5 3.16294 20.5263 3.09936 20.5732 3.05247C20.6201 3.00559 20.6837 2.97925 20.75 2.97925Z",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 0.729248H2.25C1.69772 0.729248 1.25 1.17696 1.25 1.72925V18.7292C1.25 19.2815 1.69772 19.7292 2.25 19.7292H23.25C23.8023 19.7292 24.25 19.2815 24.25 18.7292V1.72925C24.25 1.17696 23.8023 0.729248 23.25 0.729248Z",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.72925H24.25",
    stroke: "#C0B7D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeEditor);
export default __webpack_public_path__ + "static/media/code-editor.8df76e290ce5bf270d575f7cf89f78d6.svg";
export { ForwardRef as ReactComponent };